<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<h1 class="chaptitle"><a id="reader"></a>Dear Reader</h1>
<p class="text">I've always wanted to write a book to help young girls handle the kinds of feelings that troubled me when I was young. When I was your age, I often felt afraid and confused. I didn't feel comfortable asking questions, and sometimes everyone else seemed to understand things that baffled me. Sometimes I dreaded going to school and sometimes I felt confused or hurt because my friends didn't include me in their plans and activities. My parents argued a lot and I really hated that. I had stomachaches all the time because of these worries.</p>
<p class="textindent">If you sometimes find yourself getting confused or angry, try reading one of the pages of this book each day before you go to school. I can almost guarantee it will help you feel better. If you want to, you can share the book with your mom or dad, or a teacher or other adult you trust. It almost always feels better to talk over your thoughts with another person. And it's good for them to hear what's going on with you.</p>
<p class="textindent">Remember: You don't have to handle your problems all by yourself. Even if you don't have an adult close by who you feel comfortable talking to, there is always someone available to listen. Close your eyes and imagine your guardian angel. Picture what she looks like. Give her a name, if you like. She is always there, whenever you need her. She will never leave your side, no matter where you are or what's going on. I promise you this. But you'll have to find her by yourself. Perhaps you can find her today.</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="textindent">Your friend forever,</p>
<p class="textindent">Karen Casey</p>
<p style="text-align:center; margin-top:1pc"></p>
<p class="text">P.S. If you want to write to me, I would love to hear from you. You can contact me through my Web site, <i><a href="http://www.womens-spirituality.com" target="_blank">www.womens-spirituality.com</a></i>, or in care of my publisher, Conari Press, 500 Third Street, Suite 230, San Francisco, CA 94107.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-dearreader.vue?00dc452c